/**
 * Abstract Data Model that serves as a basis for other derived Models
 * and provides common functionality across all Models
 *
 * @class AbstractViewModel
 */
var AbstractDataModel = function () {};

/**
 * This method creates a subscription (observable) in a ViewModel that
 * is derived from a KnockoutJS observable variable contained in another
 * object.
 *
 * @param {String} sParamName The name of the observable value to subscribe to
 * @param {Object} oDependentObject An object containing the observable
 * @returns {ObservedVariable} Returns a reference to the observed variable
 *                            contained by the dependent object
 */
AbstractDataModel.prototype.dependentObservable = function (sParamName, oDependentObject) {
	return ko.computed(function () {
		return oDependentObject[sParamName]();
	});
};


/**
 * Converts the provided val to a Boolean, or Null
 *
 * @param {Mixed} val
 * @returns {Boolean | Null}
 */
AbstractDataModel.prototype.parseBoolean = function (val) {
	if (val === true || (typeof val === 'string' && val.toLowerCase() === 'true')) {
		return true;
	}
	else if (val === false || (typeof val === 'string' && val.toLowerCase() === 'false')) {
		return false;
	}
	return null;
};


/**
 * Converts a provided string into a Date object
 *
 * @param {String} sDateString
 * @returns {Date | Null}
 */
AbstractDataModel.prototype.parseDate = function (sDateString) {
	// Parse the provided string into an epoch timestamp
	var sTimeStamp = Date.parse(sDateString);

	// If the date could not be parsed, return null
	if (isNaN(sTimeStamp)) {
		return null;
	}

	// Otherwise, return a new Date object, keyed from that epoch time
	return new Date(sTimeStamp);
};


module.exports = AbstractDataModel;
